// extracted by mini-css-extract-plugin
export default {"page":"Page_page__HUmlB","key-image":"Page_key-image__Ok9DB","title":"Page_title__WeJwx","richtext":"Page_richtext__VQqsN"};